module.exports = __webpack_public_path__ + "static/media/product3.58a02025.jpg";